// extracted by mini-css-extract-plugin
module.exports = {"myVideo":"VideoBackground_myVideo__3L7I5"};